var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.home) ? _c('div', {
    staticClass: "project",
    class: {
      'expanded': _vm.isCurrentProject(_vm.project.$id) && _vm.popupOpened
    }
  }, [_c('div', {
    staticClass: "project__content",
    on: {
      "click": function($event) {
        _vm.expandElement(_vm.project.$id, $event)
      }
    }
  }, [_c('div', {
    staticClass: "project__logo"
  }, [(_vm.project.text.item.logo) ? _c('img', {
    staticClass: "project__logo-img project__logo-img_color",
    attrs: {
      "src": _vm.project.text.item.logo.$src,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project.text.item.logo_bw) ? _c('img', {
    staticClass: "project__logo-img project__logo-img_white",
    attrs: {
      "src": _vm.project.text.item.logo_bw.$src,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "project__info"
  }, [_c('div', {
    staticClass: "project__line project__title"
  }, [_vm._v(_vm._s(_vm.project.text.item.company_name))]), _vm._v(" "), _c('div', {
    staticClass: "project__line project__industry",
    domProps: {
      "innerHTML": _vm._s(_vm.project.text.item.text_industry)
    }
  }), _vm._v(" "), (_vm.project.$exited) ? _c('div', {
    staticClass: "project__line project__exited",
    domProps: {
      "innerHTML": _vm._s(_vm.page.home.project_status)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "project__hidden light-bg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "project__close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetProject($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-exit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "project__top"
  }, [_c('div', {
    staticClass: "project__logo"
  }, [(_vm.project.text.item.logo) ? _c('img', {
    attrs: {
      "src": _vm.project.text.item.logo.$src,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "project__info"
  }, [_c('div', {
    staticClass: "project__line project__title"
  }, [_vm._v(_vm._s(_vm.project.text.item.company_name))]), _vm._v(" "), _c('div', {
    staticClass: "project__line project__date"
  }, [_vm._v(_vm._s(_vm.project.$project_year))]), _vm._v(" "), _c('div', {
    staticClass: "project__line project__industry",
    domProps: {
      "innerHTML": _vm._s(_vm.project.text.item.text_industry)
    }
  }), _vm._v(" "), (_vm.project.$exited) ? _c('div', {
    staticClass: "project__line project__exited",
    domProps: {
      "innerHTML": _vm._s(_vm.page.home.project_status)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "project__text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.text.item.text_content)
    }
  }), _vm._v(" "), (_vm.project.$site_link) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.project.$site_link
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.project.$site_link.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '')))])]) : _vm._e()]), _vm._v(" "), (_vm.project.photo) ? _c('div', {
    staticClass: "project__photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.project.photo.large.$src,
      "alt": ""
    }
  })]) : _vm._e()])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-615c0662","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project.vue
// module id = 197
// module chunks = 0